module.exports = __webpack_public_path__ + "img/tablas.4da05855.png";